import createVueArchive from '../../../../src/scripts/components/create-vue-archive.js';

window.addEventListener( 'DOMContentLoaded', () => createVueArchive( 'vrgz-vacancy-archive' ) );


